import { RouteRecordRaw } from 'vue-router';

const timeClockRoutes: Array<RouteRecordRaw> = [
   {
      path: 'list',
      name: 'time-clock-list',
      component: () => import('@/modules/timeClock/components/TimeClocks.vue'),
   },
   {
      path: 'scan/:syncId',
      name: 'time-clock-scan',
      component: () => import('@/modules/timeClock/components/TimeClockScan.vue'),
   },
];
export default timeClockRoutes;
